var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Link = require('react-router').Link;
var PartnerLogos = require('../../components/partnerLogos.jsx');
var AppPromo = require('../../components/appPromo.jsx');
var Features = require('./layout/features.jsx');

var App = createReactClass({

    handleClickTracking: function(e) {
        var label = 'App Landing Page';
        var action = 'Click';
        this.props.recordDownloadClick(action, label);
    },

	pageTitle: 'Symptom Tracker App | GI Monitor, Symptom Diary & IBS App',

	render: function(){

		return (
			<div className="content fadeIn animated duration-750 delay-600">
          <Helmet
              title={this.pageTitle}
              meta={[{
                  name: 'description',
                  content: 'Monitor, understand and manage your Gi symptoms with our free app, MyGiHealth.'
              }]}
          />
			    <div id="hero-container">
			        <section id="hero">
			            <div className="row">
                            <div className="large-5 large-push-5 column">
			                    <div className="row fadeIn animated duration-1500 delay-1000" id="headline">
			                        <div className="text">
			                            <h1>Get better &amp; <strong>stay better.</strong></h1>
			                            <p >Monitor, understand and manage your GI symptoms with our free app, MyGiHealth</p>
			                        </div>
                                    <div className="partners">
                                        <PartnerLogos />
                                    </div>
		                            <div className="button-container clearfix">
										<a className="download-app" href="http://get.mygihealth.io/downloadtheapp" onClick={this.handleClickTracking}>
                                            <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
			                            </a>
										<p><span>Don’t have an iPhone?</span> <Link to="/register">Sign Up Online</Link></p>
		                            </div>
			                    </div>
			                </div>
			                <div className="large-5 large-pull-7 column">
								<div className="iphone-wrapper">
									<div id="iphone" className="iphone fadeInDown animated ease-in duration-1200 delay-600">
				                        <div className="screen knowledge"></div>
				                    </div>
								</div>
			                </div>
			            </div>
			            <div className="row">
			                <div className=""></div>
			            </div>
			        </section>
			    </div>
				<Features />
			    <div id="tertiary">
			        <div className="row heading">
			            <h2>Our Founders</h2>
			        </div>
			        <div className="row column expanded" id="brennan">
						<div className="row">
							<div className="img large-6 column"></div>
							<div className="text large-6 column">
								<blockquote>
		                            <p>We are in a unique position at the intersection of cutting edge technology & forward-thinking health research, and we&#39;re just getting started.</p>
		                        </blockquote>
								<h3>Dr. Brennan Spiegel</h3>
								<p className="tag">MD, MSHS, RFF, FACG, AGAF</p>
								<p className="position">Co-founder/Co-Chief Medical Officer</p>
								<ul className="no-bullet">
									<li>Professor of Medicine, Public Health, & Digestive Diseases</li>
									<li>Director of Health Services Research for Cedars-Sinai Health System</li>
									<li>Co-Editor-in-Chief of the American Journal of Gastroenterology</li>
								</ul>
							</div>
						</div>
			        </div>
			        <div className="row column expanded" id="bill">
		                <div className="row">
		                    <div className="img large-6 large-push-6 column"></div>
		                    <div className="text large-6 large-pull-6 column">
		                        <blockquote>
		                            <p>Harnessing technology to help an exponentially higher number of patients continues to be a very exciting prospect to me.</p>
		                        </blockquote>
		                        <h3>Dr. William D. Chey</h3>
		                        <p className="tag">MD, FACP, RFF, FACG, AGAF</p>
		                        <p className="position">Co-founder/Co-Chief Medical Officer</p>
		                        <ul className="no-bullet">
									<li>Professor of Medicine</li>
									<li>Director of the GI Physiology Lab, University of Michigan</li>
									<li>Former Co-Editor-in-Chief of the American College of Gastroenterology</li>
								</ul>
		                    </div>
		                </div>
			        </div>
			    </div>
			    <div id="quaternary">
			        <div className="row heading">
			            <h2>Industry Buzz</h2>
			        </div>
					<div className="row column x-large-9 large-10">
				        <div className="testimonial medium-4 small-12 column">
				            <div className="image">
				                <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mobihealthnews-logo.jpg" alt="" />
				            </div>
				            <div className="quote">
				                <blockquote className="media">"Patients fill out a questionnaire, and [MyGiHealth] translates that into a history of patient illness -- one so detailed and clear that in a blind test, <span className="text-medium">independent reviewers and medicare billers universally found it superior</span> to the patient history created by a doctor."</blockquote>
				            </div>
				        </div>
				        <div className="testimonial medium-4 small-12 column">
				            <div className="image">
				                <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/dr-bonnie-360.jpg" alt="" />
				            </div>
				            <div className="quote">
				                <blockquote className="media">"MyGiHealth’s visuals and tutorials provide a channel that keeps its users <span className="text-medium">on track and away from harmful misinformation</span>."</blockquote>
				            </div>
				        </div>
				        <div className="testimonial medium-4 small-12 column">
				            <div className="image">
				                <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/william-b-salt.jpg" alt="" />
				            </div>
				            <div className="quote">
				                <blockquote className="media">"I regularly 'prescribe' the remarkable MyGiHealth Mobile App for my patients to complete prior to visits. It <span className="text-medium">significantly improves quality of care and efficiency</span> by increasing the likelihood an accurate history will be expressed, which is essential for arriving at the diagnosis. Thereafter, patients can both monitor as well as learn about their symptoms."</blockquote>
				            </div>
				        </div>
					</div>
			    </div>
				<div className="app-promo-wrapper">
					<div className="row column">
						<AppPromo
							pageTitle={this.pageTitle}
							recordDownloadClick={this.props.recordDownloadClick} />
					</div>
				</div>
			    <div id="preload">
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-dashboard-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-survey-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-learning-center-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-treatment-center-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-myQ-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/diagram-bg-1-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/diagram-bg-2-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/diagram-bg-3-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/diagram-bg-4-v3.png" alt="" />
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/diagram-bg-5-v3.png" alt="" />
			    </div>
			</div>
        )
    }
});

module.exports = App;



// WEBPACK FOOTER //
// ./src/common/routes/app/components/app.jsx